import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translations
const resources = {
  it: {
    translation: {
      // Common
      "welcome": "Benvenuto",
      "loading": "Caricamento...",
      "save": "Salva",
      "cancel": "Annulla",
      "delete": "Elimina",
      "edit": "Modifica",
      "close": "Chiudi",
      "send": "Invia",
      "back": "Indietro",
      "next": "Avanti",
      "skip": "Salta",
      
      // Navigation
      "nav.dashboard": "Dashboard",
      "nav.events": "Eventi",
      "nav.scanner": "Scanner",
      "nav.settings": "Impostazioni",
      "nav.admin": "Admin",
      "nav.logout": "Esci",
      
      // Events
      "events.title": "I Miei Eventi",
      "events.create": "Nuovo Evento",
      "events.type.in_person": "Dal Vivo",
      "events.type.online": "Online",
      "events.type.hybrid": "Ibrido",
      "events.streaming_url": "Link Diretta",
      "events.location": "Luogo",
      "events.start_date": "Data Inizio",
      "events.end_date": "Data Fine",
      "events.description": "Descrizione",
      
      // Tickets
      "tickets.buy": "Acquista Biglietti",
      "tickets.price": "Prezzo",
      "tickets.available": "Disponibili",
      "tickets.sold_out": "Esauriti",
      
      // Messages
      "messages.title": "Messaggi Clienti",
      "messages.unread": "{{count}} non letti",
      "messages.send_to_organizer": "Contatta l'Organizzatore",
      "messages.your_name": "Il tuo nome",
      "messages.your_email": "La tua email",
      "messages.your_message": "Il tuo messaggio",
      "messages.sent": "Messaggio inviato con successo",
      
      // Reviews
      "reviews.title": "Recensioni",
      "reviews.leave_review": "Lascia una Recensione",
      "reviews.rating": "Valutazione",
      "reviews.comment": "Commento",
      
      // Tour
      "tour.welcome": "Benvenuto su ZonePass!",
      "tour.step": "Passo {{current}} di {{total}}",
      "tour.dashboard": "Dashboard - Panoramica dei tuoi eventi",
      "tour.events": "Eventi - Crea e gestisci eventi",
      "tour.scanner": "Scanner - Scansiona QR code",
      "tour.settings": "Impostazioni - Configura pagamenti",
      "tour.ready": "Sei pronto!",
      
      // Payment
      "payment.method": "Metodo di Pagamento",
      "payment.iban": "IBAN",
      "payment.paypal": "PayPal",
      "payment.stripe": "Stripe",
      
      // Terms
      "terms.disclaimer": "ZonePass non è responsabile degli eventi organizzati né dei rimborsi",
      "terms.payment_direct": "I pagamenti vanno direttamente all'organizzatore",
      
      // Landing Page
      "landing.hero.title": "Gestisci Eventi di Ogni Dimensione",
      "landing.hero.subtitle": "Dalla Festa al Festival",
      "landing.hero.description": "Biglietteria digitale, QR code personalizzabili, check-in multi-zona e statistiche real-time. Tutto in un'unica piattaforma professionale.",
      "landing.hero.cta": "Inizia Gratis - Nessuna Carta",
      
      // Pricing
      "pricing.free": "Gratis",
      "pricing.forever": "per sempre",
      "pricing.perMonth": "al mese",
      "pricing.perYear": "all'anno",
      "pricing.basic.description": "Perfetto per eventi piccoli e gratuiti",
      "pricing.pro.description": "Per organizzatori professionisti",
      "pricing.full.description": "Per eventi di media-grande scala",
      "pricing.cta.free": "Inizia Gratis",
      "pricing.cta.start": "Inizia Ora",
      "pricing.cta.contact": "Contattaci",
      
      // Features
      "features.up_to": "Fino a {{count}} partecipanti",
      "features.guest_list": "Guest list digitale",
      "features.scanners": "{{count}} dispositivo scanner",
      "features.scanners_plural": "{{count}} dispositivi scanner",
      "features.no_online": "NO eventi online",
      "features.online_streaming": "Eventi online/streaming",
      "features.stats_basic": "Statistiche base",
      "features.stats_advanced": "Statistiche avanzate",
      "features.support_email": "Supporto email",
      "features.support_priority": "Supporto prioritario",
      "features.support_247": "Supporto prioritario 24/7",
      "features.pdf_reports": "Report PDF personalizzati",
      "features.branding": "Branding personalizzato",
      "features.everything_plus": "Tutto del {{plan}} +",
      "features.unlimited_participants": "Partecipanti illimitati",
      "features.unlimited_scanners": "Scanner illimitati",
      "features.custom_api": "API personalizzate",
      "features.custom_integrations": "Integrazioni custom",
      "features.dedicated_manager": "Manager dedicato",
      "features.sla": "SLA 99.9%",
      "pricing.custom": "Custom",
      "pricing.contact_us": "contattaci",
      "pricing.enterprise.description": "Per grandi eventi e festival",
    }
  },
  en: {
    translation: {
      // Common
      "welcome": "Welcome",
      "loading": "Loading...",
      "save": "Save",
      "cancel": "Cancel",
      "delete": "Delete",
      "edit": "Edit",
      "close": "Close",
      "send": "Send",
      "back": "Back",
      "next": "Next",
      "skip": "Skip",
      
      // Navigation
      "nav.dashboard": "Dashboard",
      "nav.events": "Events",
      "nav.scanner": "Scanner",
      "nav.settings": "Settings",
      "nav.admin": "Admin",
      "nav.logout": "Logout",
      
      // Events
      "events.title": "My Events",
      "events.create": "New Event",
      "events.type.in_person": "In Person",
      "events.type.online": "Online",
      "events.type.hybrid": "Hybrid",
      "events.streaming_url": "Streaming Link",
      "events.location": "Location",
      "events.start_date": "Start Date",
      "events.end_date": "End Date",
      "events.description": "Description",
      
      // Tickets
      "tickets.buy": "Buy Tickets",
      "tickets.price": "Price",
      "tickets.available": "Available",
      "tickets.sold_out": "Sold Out",
      
      // Messages
      "messages.title": "Customer Messages",
      "messages.unread": "{{count}} unread",
      "messages.send_to_organizer": "Contact Organizer",
      "messages.your_name": "Your name",
      "messages.your_email": "Your email",
      "messages.your_message": "Your message",
      "messages.sent": "Message sent successfully",
      
      // Reviews
      "reviews.title": "Reviews",
      "reviews.leave_review": "Leave a Review",
      "reviews.rating": "Rating",
      "reviews.comment": "Comment",
      
      // Tour
      "tour.welcome": "Welcome to ZonePass!",
      "tour.step": "Step {{current}} of {{total}}",
      "tour.dashboard": "Dashboard - Overview of your events",
      "tour.events": "Events - Create and manage events",
      "tour.scanner": "Scanner - Scan QR codes",
      "tour.settings": "Settings - Configure payments",
      "tour.ready": "You're ready!",
      
      // Payment
      "payment.method": "Payment Method",
      "payment.iban": "IBAN",
      "payment.paypal": "PayPal",
      "payment.stripe": "Stripe",
      
      // Terms
      "terms.disclaimer": "ZonePass is not responsible for organized events nor refunds",
      "terms.payment_direct": "Payments go directly to the organizer",
      
      // Landing Page
      "landing.hero.title": "Manage Events of Any Size",
      "landing.hero.subtitle": "From Party to Festival",
      "landing.hero.description": "Digital ticketing, customizable QR codes, multi-zone check-in and real-time statistics. Everything in one professional platform.",
      "landing.hero.cta": "Start Free - No Card Required",
      
      // Pricing
      "pricing.free": "Free",
      "pricing.forever": "forever",
      "pricing.perMonth": "per month",
      "pricing.perYear": "per year",
      "pricing.basic.description": "Perfect for small and free events",
      "pricing.pro.description": "For professional organizers",
      "pricing.full.description": "For medium to large scale events",
      "pricing.cta.free": "Get Started for Free",
      "pricing.cta.start": "Start Now",
      "pricing.cta.contact": "Contact Us",
      
      // Features
      "features.up_to": "Up to {{count}} participants",
      "features.guest_list": "Digital guest list",
      "features.scanners": "{{count}} scanner device",
      "features.scanners_plural": "{{count}} scanner devices",
      "features.no_online": "NO online events",
      "features.online_streaming": "Online/streaming events",
      "features.stats_basic": "Basic statistics",
      "features.stats_advanced": "Advanced statistics",
      "features.support_email": "Email support",
      "features.support_priority": "Priority support",
      "features.support_247": "Priority support 24/7",
      "features.pdf_reports": "Custom PDF reports",
      "features.branding": "Custom branding",
      "features.everything_plus": "Everything from {{plan}} +",
      "features.unlimited_participants": "Unlimited participants",
      "features.unlimited_scanners": "Unlimited scanners",
      "features.custom_api": "Custom APIs",
      "features.custom_integrations": "Custom integrations",
      "features.dedicated_manager": "Dedicated manager",
      "features.sla": "99.9% SLA",
      "pricing.custom": "Custom",
      "pricing.contact_us": "contact us",
      "pricing.enterprise.description": "For large events and festivals",
    }
  },
  es: {
    translation: {
      "welcome": "Bienvenido",
      "loading": "Cargando...",
      "save": "Guardar",
      "cancel": "Cancelar",
      "nav.dashboard": "Panel",
      "nav.events": "Eventos",
      "nav.scanner": "Escáner",
      "nav.settings": "Configuración",
      "events.create": "Nuevo Evento",
      "events.type.in_person": "Presencial",
      "events.type.online": "Online",
      "events.type.hybrid": "Híbrido",
      "tickets.buy": "Comprar Entradas",
      "messages.title": "Mensajes de Clientes",
      "terms.disclaimer": "ZonePass no es responsable de los eventos organizados ni de los reembolsos",
      "landing.hero.title": "Gestiona Eventos de Cualquier Tamaño",
      "landing.hero.subtitle": "Desde Fiesta hasta Festival",
      "landing.hero.description": "Venta de entradas digital, códigos QR personalizables, check-in multi-zona y estadísticas en tiempo real. Todo en una plataforma profesional.",
      "landing.hero.cta": "Empezar Gratis - Sin Tarjeta",
      
      // Pricing
      "pricing.free": "Gratis",
      "pricing.forever": "para siempre",
      "pricing.perMonth": "al mes",
      "pricing.perYear": "al año",
      "pricing.basic.description": "Perfecto para eventos pequeños y gratuitos",
      "pricing.pro.description": "Para organizadores profesionales",
      "pricing.full.description": "Para eventos de mediana a gran escala",
      "pricing.cta.free": "Empezar Gratis",
      "pricing.cta.start": "Empezar Ahora",
      "pricing.cta.contact": "Contáctanos",
      
      // Features
      "features.up_to": "Hasta {{count}} participantes",
      "features.guest_list": "Lista de invitados digital",
      "features.scanners": "{{count}} dispositivo escáner",
      "features.scanners_plural": "{{count}} dispositivos escáner",
      "features.no_online": "NO eventos online",
      "features.online_streaming": "Eventos online/streaming",
      "features.stats_basic": "Estadísticas básicas",
      "features.stats_advanced": "Estadísticas avanzadas",
      "features.support_email": "Soporte por email",
      "features.support_priority": "Soporte prioritario",
      "features.support_247": "Soporte prioritario 24/7",
      "features.pdf_reports": "Informes PDF personalizados",
      "features.branding": "Branding personalizado",
      "features.everything_plus": "Todo de {{plan}} +",
      "features.unlimited_participants": "Participantes ilimitados",
      "features.unlimited_scanners": "Escáneres ilimitados",
      "features.custom_api": "APIs personalizadas",
      "features.custom_integrations": "Integraciones personalizadas",
      "features.dedicated_manager": "Gerente dedicado",
      "features.sla": "SLA 99.9%",
      "pricing.custom": "Personalizado",
      "pricing.contact_us": "contáctanos",
      "pricing.enterprise.description": "Para grandes eventos y festivales",
    }
  },
  fr: {
    translation: {
      "welcome": "Bienvenue",
      "loading": "Chargement...",
      "save": "Enregistrer",
      "cancel": "Annuler",
      "nav.dashboard": "Tableau de bord",
      "nav.events": "Événements",
      "nav.scanner": "Scanner",
      "nav.settings": "Paramètres",
      "events.create": "Nouvel Événement",
      "events.type.in_person": "En Personne",
      "events.type.online": "En Ligne",
      "events.type.hybrid": "Hybride",
      "tickets.buy": "Acheter Billets",
      "messages.title": "Messages Clients",
      "terms.disclaimer": "ZonePass n'est pas responsable des événements organisés ni des remboursements",
      "landing.hero.title": "Gérez des Événements de Toute Taille",
      "landing.hero.subtitle": "De la Fête au Festival",
      "landing.hero.description": "Billetterie numérique, QR codes personnalisables, check-in multi-zones et statistiques en temps réel. Tout dans une plateforme professionnelle.",
      "landing.hero.cta": "Commencer Gratuitement - Sans Carte",
      
      // Pricing
      "pricing.free": "Gratuit",
      "pricing.forever": "pour toujours",
      "pricing.perMonth": "par mois",
      "pricing.perYear": "par an",
      "pricing.basic.description": "Parfait pour les petits événements gratuits",
      "pricing.pro.description": "Pour les organisateurs professionnels",
      "pricing.full.description": "Pour les événements de moyenne à grande échelle",
      "pricing.cta.free": "Commencer Gratuitement",
      "pricing.cta.start": "Commencer Maintenant",
      "pricing.cta.contact": "Nous Contacter",
      
      // Features
      "features.up_to": "Jusqu'à {{count}} participants",
      "features.guest_list": "Liste d'invités numérique",
      "features.scanners": "{{count}} appareil scanner",
      "features.scanners_plural": "{{count}} appareils scanner",
      "features.no_online": "PAS d'événements en ligne",
      "features.online_streaming": "Événements en ligne/streaming",
      "features.stats_basic": "Statistiques de base",
      "features.stats_advanced": "Statistiques avancées",
      "features.support_email": "Support par email",
      "features.support_priority": "Support prioritaire",
      "features.support_247": "Support prioritaire 24/7",
      "features.pdf_reports": "Rapports PDF personnalisés",
      "features.branding": "Branding personnalisé",
      "features.everything_plus": "Tout de {{plan}} +",
      "features.unlimited_participants": "Participants illimités",
      "features.unlimited_scanners": "Scanners illimités",
      "features.custom_api": "APIs personnalisées",
      "features.custom_integrations": "Intégrations personnalisées",
      "features.dedicated_manager": "Gestionnaire dédié",
      "features.sla": "SLA 99.9%",
      "pricing.custom": "Personnalisé",
      "pricing.contact_us": "contactez-nous",
      "pricing.enterprise.description": "Pour les grands événements et festivals",
    }
  },
  de: {
    translation: {
      "welcome": "Willkommen",
      "loading": "Wird geladen...",
      "save": "Speichern",
      "cancel": "Abbrechen",
      "nav.dashboard": "Dashboard",
      "nav.events": "Veranstaltungen",
      "nav.scanner": "Scanner",
      "nav.settings": "Einstellungen",
      "events.create": "Neue Veranstaltung",
      "events.type.in_person": "Vor Ort",
      "events.type.online": "Online",
      "events.type.hybrid": "Hybrid",
      "tickets.buy": "Tickets Kaufen",
      "messages.title": "Kundennachrichten",
      "terms.disclaimer": "ZonePass ist nicht verantwortlich für organisierte Veranstaltungen oder Rückerstattungen",
      "landing.hero.title": "Verwalten Sie Events jeder Größe",
      "landing.hero.subtitle": "Von der Party bis zum Festival",
      "landing.hero.description": "Digitale Tickets, anpassbare QR-Codes, Multi-Zonen-Check-in und Echtzeit-Statistiken. Alles in einer professionellen Plattform.",
      "landing.hero.cta": "Kostenlos Starten - Keine Karte Erforderlich",
      
      // Pricing
      "pricing.free": "Kostenlos",
      "pricing.forever": "für immer",
      "pricing.perMonth": "pro Monat",
      "pricing.perYear": "pro Jahr",
      "pricing.basic.description": "Perfekt für kleine und kostenlose Veranstaltungen",
      "pricing.pro.description": "Für professionelle Veranstalter",
      "pricing.full.description": "Für mittelgroße bis große Veranstaltungen",
      "pricing.cta.free": "Kostenlos Starten",
      "pricing.cta.start": "Jetzt Starten",
      "pricing.cta.contact": "Kontaktieren Sie Uns",
      
      // Features
      "features.up_to": "Bis zu {{count}} Teilnehmer",
      "features.guest_list": "Digitale Gästeliste",
      "features.scanners": "{{count}} Scanner-Gerät",
      "features.scanners_plural": "{{count}} Scanner-Geräte",
      "features.no_online": "KEINE Online-Veranstaltungen",
      "features.online_streaming": "Online-/Streaming-Veranstaltungen",
      "features.stats_basic": "Basis-Statistiken",
      "features.stats_advanced": "Erweiterte Statistiken",
      "features.support_email": "E-Mail-Support",
      "features.support_priority": "Prioritäts-Support",
      "features.support_247": "Prioritäts-Support 24/7",
      "features.pdf_reports": "Benutzerdefinierte PDF-Berichte",
      "features.branding": "Individuelles Branding",
      "features.everything_plus": "Alles von {{plan}} +",
      "features.unlimited_participants": "Unbegrenzte Teilnehmer",
      "features.unlimited_scanners": "Unbegrenzte Scanner",
      "features.custom_api": "Benutzerdefinierte APIs",
      "features.custom_integrations": "Benutzerdefinierte Integrationen",
      "features.dedicated_manager": "Dedizierter Manager",
      "features.sla": "99,9% SLA",
      "pricing.custom": "Individuell",
      "pricing.contact_us": "kontaktieren Sie uns",
      "pricing.enterprise.description": "Für große Events und Festivals",
    }
  }
};

// Force Italian language only - disable auto-detection
i18n
  // .use(LanguageDetector)  // DISABLED - Forcing Italian only
  .use(initReactI18next)
  .init({
    resources,
    lng: 'it', // Force Italian
    fallbackLng: 'it',
    debug: false,
    supportedLngs: ['it'], // Only Italian supported
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: [], // Disable all detection
      caches: [] // Don't cache language preference
    }
  });

export default i18n;
